"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLengthJson = exports.Length = exports.LengthUnitsTexts = exports.LengthUnits = void 0;
const constants_1 = require("./constants");
const Quantity_1 = require("./Quantity");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var LengthUnits;
(function (LengthUnits) {
    LengthUnits["default"] = "m";
    LengthUnits["km"] = "km";
    LengthUnits["m"] = "m";
    LengthUnits["cm"] = "cm";
    LengthUnits["mm"] = "mm";
    LengthUnits["um"] = "um";
    LengthUnits["mil"] = "mil";
    LengthUnits["inch"] = "inch";
    LengthUnits["ft"] = "ft";
})(LengthUnits = exports.LengthUnits || (exports.LengthUnits = {}));
exports.LengthUnitsTexts = {
    [LengthUnits.default]: 'm',
    [LengthUnits.km]: 'km',
    [LengthUnits.m]: 'm',
    [LengthUnits.cm]: 'cm',
    [LengthUnits.mm]: 'mm',
    [LengthUnits.um]: 'µm',
    [LengthUnits.mil]: 'mil',
    [LengthUnits.inch]: 'inch',
    [LengthUnits.ft]: 'ft',
};
class Length extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'LengthAccessor';
        this.defaultUnit = 'm';
        this.unitTexts = exports.LengthUnitsTexts;
    }
    static getUnitText(unit) {
        return exports.LengthUnitsTexts[unit];
    }
    static fromJson(q) {
        if (!(0, echain_shared_ts_utils_1.isValueInEnum)(LengthUnits, q.Unit)) {
            throw new Error(`Length.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new Length(q);
    }
    static km(v) {
        return new Length(v, LengthUnits.km);
    }
    static m(v) {
        return new Length(v, LengthUnits.m);
    }
    static cm(v) {
        return new Length(v, LengthUnits.cm);
    }
    static mm(v) {
        return new Length(v, LengthUnits.mm);
    }
    static um(v) {
        return new Length(v, LengthUnits.um);
    }
    static mil(v) {
        return new Length(v, LengthUnits.mil);
    }
    static ft(v) {
        return new Length(v, LengthUnits.ft);
    }
    static inch(v) {
        return new Length(v, LengthUnits.inch);
    }
    set km(v) {
        this.setValueUnit(v, LengthUnits.km);
    }
    get km() {
        return this.m / 1000;
    }
    set m(v) {
        this.setValueUnit(v, LengthUnits.m);
    }
    get m() {
        switch (this.unit) {
            case LengthUnits.km:
                return this.value * 1000;
            case LengthUnits.m:
                return this.value;
            case LengthUnits.cm:
                return this.value / 100;
            case LengthUnits.mm:
                return this.value / 1000;
            case LengthUnits.um:
                return this.value / 1000000;
            case LengthUnits.mil:
                return (this.value / constants_1.FACTOR_DISTANCE_KILO) * 1000;
            case LengthUnits.ft:
                return this.value / constants_1.FACTOR_DISTANCE;
            case LengthUnits.inch:
                return this.value / constants_1.FACTOR_DISTANCE_MILLI / 1000;
        }
        throw new Error(`Length.get m: unknown unit ${this.unit}`);
    }
    set cm(v) {
        this.value = +v;
        this.unit = LengthUnits.cm;
    }
    get cm() {
        return this.unit === LengthUnits.cm ? this.value : this.m * 100;
    }
    set mm(v) {
        this.value = +v;
        this.unit = LengthUnits.mm;
    }
    get mm() {
        return this.unit === LengthUnits.mm ? this.value : this.m * 1000;
    }
    set um(v) {
        this.value = +v;
        this.unit = LengthUnits.um;
    }
    get um() {
        return this.unit === LengthUnits.um ? this.value : this.m * 1000000;
    }
    set mil(v) {
        this.value = +v;
        this.unit = LengthUnits.mil;
    }
    get mil() {
        return this.unit === LengthUnits.mil ? this.value : this.km * constants_1.FACTOR_DISTANCE_KILO;
    }
    set ft(v) {
        this.value = +v;
        this.unit = LengthUnits.ft;
    }
    get ft() {
        return this.unit === LengthUnits.ft ? this.value : this.m * constants_1.FACTOR_DISTANCE;
    }
    set inch(v) {
        this.value = +v;
        this.unit = LengthUnits.inch;
    }
    get inch() {
        return this.unit === LengthUnits.inch ? this.value : this.m * 1000 * constants_1.FACTOR_DISTANCE_MILLI;
    }
    clone() {
        return Length.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case LengthUnits.m:
                return this.m;
            case LengthUnits.km:
                return this.km;
            case LengthUnits.cm:
                return this.cm;
            case LengthUnits.mm:
                return this.mm;
            case LengthUnits.um:
                return this.um;
            case LengthUnits.mil:
                return this.mil;
            case LengthUnits.inch:
                return this.inch;
            case LengthUnits.ft:
                return this.ft;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
    }
}
exports.Length = Length;
Length.units = LengthUnits;
const isLengthJson = (l) => {
    return (0, Quantity_1.isQuantityJson)(l) && (0, echain_shared_ts_utils_1.isValueInEnum)(LengthUnits, l.Unit);
};
exports.isLengthJson = isLengthJson;
//# sourceMappingURL=Length.js.map